export default __webpack_public_path__ + "static/optimizing-logistics-operations-9b8123868417d541d1ef4c1022f795fc.png";